import { useGetOne } from 'react-admin';

export function useClaimReimbursement(claimId) {
  return useGetOne(
    'claims',
    { id: `${claimId}/reimbursements` },
    {
      enabled: !!claimId,
      select: response => {
        return response?.list;
      },
    }
  );
}
